export default __webpack_public_path__ + "static/media/watch-film-button.95302a24.png";